/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'mbqi9ZCjndjWAc4u9WTw1h.jpg': { uri: '/images/mbqi9ZCjndjWAc4u9WTw1h.jpg' },
'rozWhTtP1gMqEYErWBT95W.png': { uri: '/images/rozWhTtP1gMqEYErWBT95W.png' },
'pvgFEit2hMWG3QGvUxJGTm.png': { uri: '/images/pvgFEit2hMWG3QGvUxJGTm.png' },
'ew5PmshakSaKS5QsEYPBnc.png': { uri: '/images/ew5PmshakSaKS5QsEYPBnc.png' },
'vAuaG1NT3sL7Ls4ECi7XjC.png': { uri: '/images/vAuaG1NT3sL7Ls4ECi7XjC.png' }
}

export default imageStaticSourcesByFileName
